<span class="text-3xl">{{ 'clientService.title' | translate }}</span>

<p>{{ 'clientService.description' | translate }}</p>
<button
  kendoButton
  themeColor="primary"
  class="uppercase"
  maximizerShowcaseBookDemo
>
  {{ 'clientService.button.action' | translate }}
</button>
